import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import _ from "@/boot/lodash";

// Types
import { IState } from "@/store";
import { IBillingCycle, IBillingTermsOption } from "@/models/constants";

@Component({
  computed: {
    ...mapGetters({
      getBillingCycleName: "constants/getBillingCycleName"
    }),
    ...mapState({
      billingCycles: (state: IState) => state.constants.billingCycles
    })
  }
})
export default class BillingCyclesStore extends Vue {
  // Getters
  public getBillingCycleName!: (billingCycleMonths: number) => string;

  public billingCycles!: IBillingCycle[];
  public billingCyclesLoaded = false;

  public async created() {
    await this.getBillingCycles();
    this.billingCyclesLoaded = true;
  }

  public getBillingCycles() {
    return this.$store.dispatch("constants/getBillingCycles");
  }

  public get billingTermsOptions(): IBillingTermsOption[] {
    return _.map(this.billingCycles, (billingTerm: IBillingCycle) => {
      return {
        value: billingTerm.months,
        label: billingTerm.name
      };
    });
  }
}
